import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { useCountdown } from '../hooks/useCountdown';
import { PRICE, REGULAR_PRICE, PRODUCT_NAME } from '../data/offer';
export function Close() {
  const time = useCountdown();
  return <section className="sage-ground w-full border-y-4 border-ochre" data-id="element-56" data-mp="1v05tfy673ufd">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center sm:py-20" data-id="element-57" data-mp="1pz01w3o9ud7f">
        <h2 className="chalk-underline on-dark font-display text-[28px] text-cream sm:text-5xl" data-id="element-58" data-mp="1l16ux8f59f63">
          Stop building every session from scratch.{' '}
          <em className="text-ochre-soft" data-id="element-59" data-mp="1c7uycqhs90rt">Walk in ready.</em>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-cream/75" data-id="element-60" data-mp="1c83agg63021y">
          139 Breath Cards, 38 worksheets, six volumes and five bonuses —
          organized so you can pick, pace and run the right session in
          minutes, from a 1:1 to a full retreat.
        </p>

        {!time.expired && <div className="mt-7" data-id="element-61" data-mp="xcnnev3x56f2">
            <Countdown time={time} size="sm" tone="dark" data-id="element-62" data-mp="3vfonaqyozf6k" />
          </div>}

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-ochre/70 bg-ochre/10 px-5 py-4 text-left" data-id="element-63" data-mp="40r4dm7br86t">
          <div data-id="element-64" data-mp="3lj26qedefaac">
            <span className="block text-[10px] font-bold uppercase tracking-widest text-ochre" data-id="element-65" data-mp="3lf4nztuqgkqz">
              Complete library
            </span>
            <span className="text-[15px] font-bold text-cream" data-id="element-66" data-mp="i08xgdrnl7lz">
              {PRODUCT_NAME} — 6 Volumes + 5 Bonuses
            </span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-67" data-mp="mxirk6pzm7g5">
            <span className="text-[15px] text-cream/55 line-through" data-id="element-68" data-mp="81b1iprwebsy">
              ${REGULAR_PRICE}
            </span>
            <span className="font-display text-4xl leading-none text-cream" data-id="element-69" data-mp="czun2p2kxlks">
              ${PRICE}
            </span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-70" data-mp="2xrep6n211bkq">
          <CtaButton data-id="element-71" data-mp="2xt7unz0wlpr5">Yes, I want the library — ${PRICE}</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-cream/65" data-id="element-72" data-mp="147w9ohxksurl">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-73" data-mp="uiclcwr3g8pc">
              <span className="h-1.5 w-1.5 rounded-full bg-ochre" data-id="element-74" data-mp="pk1d2qgg6698" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}